import { IPagination } from 'app/types/common';

export interface IConnectionTypesState {
  readonly connectionTypesById?: any;
  readonly connectionTypeIds?: string[];
  readonly hasLoaded?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly selectConnectionTypeLoading?: boolean;
  readonly hasLoaded?: boolean;
  readonly showAddConnectionType?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationConnectionTypeIds?: string[];
  readonly currentConnectionTypeId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IConnectionTypesSelector
  extends IConnectionTypesState {
  readonly currentConnectionType?: any;
  readonly currentFormConnectionType?: any;
  readonly connectionTypesFilteredByOrganisationInSelectFormat?: any;
  readonly connectionTypesByTagAndIdInSelectFormat?: any;
  readonly connectionTypesByIdInSelectFormat?: any;
  readonly connectionTypesFilteredByCompetitionInSelectFormat?: any;
  readonly connectionTypesFilteredByIdInSelectFormat?: any;
}

export enum ConnectionTypesActionTypes {
  GET_ALL_CONNECTION_TYPES_REQUESTED = 'redux-app/connection-types/GET_ALL_CONNECTION_TYPES_REQUESTED',
  GET_ALL_CONNECTION_TYPES_PENDING = 'redux-app/connection-types/GET_ALL_CONNECTION_TYPES_PENDING',
  GET_ALL_CONNECTION_TYPES_SUCCESS = 'redux-app/connection-types/GET_ALL_CONNECTION_TYPES_SUCCESS',
  GET_ALL_CONNECTION_TYPES_FAIL = 'redux-app/connection-types/GET_ALL_CONNECTION_TYPES_FAIL',
  GET_CONNECTION_TYPE_REQUESTED = 'redux-app/connection-types/GET_CONNECTION_TYPE_REQUESTED',
  GET_CONNECTION_TYPE_PENDING = 'redux-app/connection-types/GET_CONNECTION_TYPE_PENDING',
  GET_CONNECTION_TYPE_SUCCESS = 'redux-app/connection-types/GET_CONNECTION_TYPE_SUCCESS',
  GET_CONNECTION_TYPE_FAIL = 'redux-app/connection-types/GET_CONNECTION_TYPE_FAIL',
  UPDATE_CONNECTION_TYPE_REQUESTED = 'redux-app/connection-types/UPDATE_CONNECTION_TYPE_REQUESTED',
  UPDATE_CONNECTION_TYPE_PENDING = 'redux-app/connection-types/UPDATE_CONNECTION_TYPE_PENDING',
  UPDATE_CONNECTION_TYPE_SUCCESS = 'redux-app/connection-types/UPDATE_CONNECTION_TYPE_SUCCESS',
  UPDATE_CONNECTION_TYPE_FAIL = 'redux-app/connection-types/UPDATE_CONNECTION_TYPE_FAIL',
  CREATE_CONNECTION_TYPE_REQUESTED = 'redux-app/connection-types/CREATE_CONNECTION_TYPE_REQUESTED',
  CREATE_CONNECTION_TYPE_PENDING = 'redux-app/connection-types/CREATE_CONNECTION_TYPE_PENDING',
  CREATE_CONNECTION_TYPE_SUCCESS = 'redux-app/connection-types/CREATE_CONNECTION_TYPE_SUCCESS',
  CREATE_CONNECTION_TYPE_FAIL = 'redux-app/connection-types/CREATE_CONNECTION_TYPE_FAIL',
  DELETE_CONNECTION_TYPE_REQUESTED = 'redux-app/connection-types/DELETE_CONNECTION_TYPE_REQUESTED',
  DELETE_CONNECTION_TYPE_PENDING = 'redux-app/connection-types/DELETE_CONNECTION_TYPE_PENDING',
  DELETE_CONNECTION_TYPE_SUCCESS = 'redux-app/connection-types/DELETE_CONNECTION_TYPE_SUCCESS',
  DELETE_CONNECTION_TYPE_FAIL = 'redux-app/connection-types/DELETE_CONNECTION_TYPE_FAIL',
  SELECT_CONNECTION_TYPE_REQUESTED = 'redux-app/connection-types/SELECT_CONNECTION_TYPE_REQUESTED',
}

export default null;
